/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './catalog.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/flex-layout/flexbox/api/layout';
import * as i3 from '@angular/flex-layout/media-query/media-monitor';
import * as i4 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i7 from '@angular/material';
import * as i8 from '@angular/flex-layout/flexbox/api/flex';
import * as i9 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i10 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i11 from '@angular/common';
import * as i12 from '@angular/forms';
import * as i13 from '@angular/router';
import * as i14 from '../../../../../../app/shared/pipes/translate.pipe';
import * as i15 from '@covalent/core/loading/directives/loading.directive';
import * as i16 from '@covalent/core/loading/services/loading.service';
import * as i17 from '../../../../../../app/agatextscreens/purchasing/catalogs/catalog/catalog.component';
import * as i18 from '@covalent/core/dialogs/services/dialog.service';
import * as i19 from '../../../../../../app/agatextscreens/purchasing/catalogs/catalog.service';
import * as i20 from '../../../../../../app/shared/services/authentication.service';
const styles_CatalogComponent:any[] = [i0.styles];
export const RenderType_CatalogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CatalogComponent,data:{}});
function View_CatalogComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'padded-container unsaved-changes'],['fxLayout','row'],['fxLayoutGap','30px']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
      (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
      {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n      '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role',
      'img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),i6.View_MdIcon_0,
      i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,i1.Renderer2,i7.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['warning'])),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['You have unsaved changes'])),(_l()(),i1.ɵted((null as any),
          ['\n  ']))],(_ck,_v) => {
    const currVal_0:any = 'row';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = '30px';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'padded-container unsaved-changes';
    _ck(_v,3,0,currVal_2);
    _ck(_v,7,0);
  },(_ck,_v) => {
    const currVal_3:any = true;
    _ck(_v,5,0,currVal_3);
  });
}
function View_CatalogComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'md-card-subtitle',
      [['class','bg-grey color-white text-only']],[[2,'mat-card-subtitle',(null as any)]],
      (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),
      0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(16384,(null as any),0,i7.MdCardSubtitle,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['',''])),i1.ɵppd(2)],(_ck,_v) => {
    const currVal_1:any = 'bg-grey color-white text-only';
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = i1.ɵunv(_v,4,0,_ck(_v,5,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'edit_catalog',_co._authService.getLanguage()));
    _ck(_v,4,0,currVal_2);
  });
}
function View_CatalogComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'md-card-subtitle',
      [['class','bg-grey color-white text-only']],[[2,'mat-card-subtitle',(null as any)]],
      (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),
      0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(16384,(null as any),0,i7.MdCardSubtitle,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['',''])),i1.ɵppd(2)],(_ck,_v) => {
    const currVal_1:any = 'bg-grey color-white text-only';
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = i1.ɵunv(_v,4,0,_ck(_v,5,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'create_catalog',_co._authService.getLanguage()));
    _ck(_v,4,0,currVal_2);
  });
}
function View_CatalogComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.createCatalog()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>(<any>_v.parent).parent).parent).parent),
        0),'create',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_CatalogComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.saveCatalog()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],(_ck,
      _v) => {
    const currVal_1:any = 'primary';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'bg-blue color-white';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>(<any>(<any>_v.parent).parent).parent).parent),
        0),'save',_co._authService.getLanguage()));
    _ck(_v,5,0,currVal_3);
  });
}
function View_CatalogComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),24,'md-card-actions',
      ([] as any[]),[[2,'mat-card-actions',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardActions,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                  '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),19,'div',[['class','table-control-buttons'],['fxFlex',''],
              ['fxFlexAlign','start'],['fxFlexAlign.lt-md','center'],['fxLayoutGap',
                  '12px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[8,(null as any)]],{gap:[0,'gap']},(null as any)),
      i1.ɵdid(737280,(null as any),0,i8.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i10.FlexAlignDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                      '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_CatalogComponent_7)),i1.ɵdid(16384,(null as any),0,
          i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                      '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CatalogComponent_8)),i1.ɵdid(16384,
          (null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                      '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-red color-white mat-button'],
          ['color','warn'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goBack()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                  '])),(_l()(),i1.ɵted((null as any),['\n              ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = '12px';
        _ck(_v,5,0,currVal_1);
        const currVal_2:any = '';
        _ck(_v,6,0,currVal_2);
        const currVal_3:any = 'start';
        const currVal_4:any = 'center';
        _ck(_v,7,0,currVal_3,currVal_4);
        const currVal_5:any = 'table-control-buttons';
        _ck(_v,8,0,currVal_5);
        const currVal_6:boolean = !_co.isEditMode;
        _ck(_v,11,0,currVal_6);
        const currVal_7:any = _co.isEditMode;
        _ck(_v,14,0,currVal_7);
        const currVal_9:any = 'warn';
        _ck(_v,18,0,currVal_9);
        const currVal_10:any = 'bg-red color-white';
        _ck(_v,20,0,currVal_10);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_8:any = (i1.ɵnov(_v,18).disabled || (null as any));
        _ck(_v,16,0,currVal_8);
        const currVal_11:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
            0),'back',_co._authService.getLanguage()));
        _ck(_v,21,0,currVal_11);
      });
}
function View_CatalogComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),137,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n              '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),69,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                  '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),32,'md-input-container',[['fxFlex',
          '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,11)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i8.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                      '])),
      (_l()(),i1.ɵeld(0,(null as any),1,9,'input',[['mdInput',''],['required','']],
          [[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
              [2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',0],
              [8,'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,21)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,21).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,21)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,21)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,28)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,28)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,28)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentCatalog.name = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i12.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i12.RequiredValidator]),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,
          [[8,(null as any)],[2,i12.NG_VALIDATORS],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[1,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],required:[1,'required']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                      '])),(_l()(),i1.ɵeld(0,(null as any),
          4,4,'md-error',([] as any[]),[[2,'mat-input-error',(null as any)]],(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(16384,[[3,4]],0,i7.MdErrorDirective,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['',''])),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                      '])),(_l()(),
          i1.ɵeld(0,(null as any),4,4,'md-error',([] as any[]),[[2,'mat-input-error',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,[[3,4]],0,i7.MdErrorDirective,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['',''])),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                  '])),(_l()(),
          i1.ɵted((null as any),['\n\n                  '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),29,'md-input-container',[['fxFlex','47%']],[[1,'align',0],
              [2,'mat-input-container',(null as any)],[2,'mat-input-invalid',(null as any)],
              [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,
                  'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,45)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,7,{_mdInputChild:0}),i1.ɵqud(335544320,8,{_placeholderChild:0}),
      i1.ɵqud(603979776,9,{_errorChildren:1}),i1.ɵqud(603979776,10,{_hintChildren:1}),
      i1.ɵqud(603979776,11,{_prefixChildren:1}),i1.ɵqud(603979776,12,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i8.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                      '])),
      (_l()(),i1.ɵeld(0,(null as any),1,8,'input',[['mdInput',''],['placeholder','SKU'],
          ['required','']],[[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)],[2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',
              0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
          'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
          'compositionstart'],[(null as any),'compositionend'],[(null as any),'focus']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,55)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,55).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,55)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,55)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,62)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,62)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,62)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentCatalog.sku = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i12.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i12.RequiredValidator]),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,
          [[8,(null as any)],[2,i12.NG_VALIDATORS],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[7,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],required:[1,'required']},(null as any)),(_l()(),
          i1.ɵted(1,['\n                      '])),(_l()(),i1.ɵeld(0,(null as any),
          4,3,'md-error',([] as any[]),[[2,'mat-input-error',(null as any)]],(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(16384,[[9,4]],0,i7.MdErrorDirective,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['required'])),(_l()(),i1.ɵted(1,['\n                      '])),(_l()(),
          i1.ɵeld(0,(null as any),4,3,'md-error',([] as any[]),[[2,'mat-input-error',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,[[9,4]],0,i7.MdErrorDirective,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['must be unique'])),(_l()(),i1.ɵted(1,['\n                  '])),(_l()(),
          i1.ɵted((null as any),['\n              '])),(_l()(),i1.ɵted((null as any),
          ['\n\n              '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),24,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,82)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,13,{_mdInputChild:0}),i1.ɵqud(335544320,14,{_placeholderChild:0}),
      i1.ɵqud(603979776,15,{_errorChildren:1}),i1.ɵqud(603979776,16,{_hintChildren:1}),
      i1.ɵqud(603979776,17,{_prefixChildren:1}),i1.ɵqud(603979776,18,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i8.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                    '])),(_l()(),
          i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,92)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,92).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,92)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,92)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,97)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,97)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,97)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentCatalog.description = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[13,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n              '])),
      (_l()(),i1.ɵted((null as any),['\n\n              '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),24,'div',[['class','padded-container'],['fxLayout','row'],
              ['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
                  '14px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},
          (null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,
          'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,
          'md-input-container',[['fxFlex','47%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,108)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,19,{_mdInputChild:0}),i1.ɵqud(335544320,20,{_placeholderChild:0}),
      i1.ɵqud(603979776,21,{_errorChildren:1}),i1.ɵqud(603979776,22,{_hintChildren:1}),
      i1.ɵqud(603979776,23,{_prefixChildren:1}),i1.ɵqud(603979776,24,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i8.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i9.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                    '])),(_l()(),
          i1.ɵeld(0,(null as any),1,7,'textarea',[['cols','4'],['mdInput','']],[[8,
              'readOnly',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
              [2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',0],
              [8,'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,118)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,118).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,118)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,118)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,123)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,123)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,123)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentCatalog.notes = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[19,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n              '])),
      (_l()(),i1.ɵted((null as any),['\n\n              '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted((null as any),['\n              \n\n              '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CatalogComponent_6)),i1.ɵdid(16384,
          (null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'column';
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = 'row';
    const currVal_3:any = 'column';
    _ck(_v,6,0,currVal_2,currVal_3);
    const currVal_4:any = '30px';
    const currVal_5:any = '14px';
    _ck(_v,7,0,currVal_4,currVal_5);
    const currVal_6:any = 'padded-container';
    _ck(_v,8,0,currVal_6);
    const currVal_18:any = '47%';
    _ck(_v,18,0,currVal_18);
    const currVal_33:any = '';
    _ck(_v,22,0,currVal_33);
    const currVal_34:any = _co.currentCatalog.name;
    _ck(_v,25,0,currVal_34);
    const currVal_35:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,28,0,_ck(_v,29,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'name',_co._authService.getLanguage())),
        '');
    const currVal_36:any = '';
    _ck(_v,28,0,currVal_35,currVal_36);
    const currVal_52:any = '47%';
    _ck(_v,52,0,currVal_52);
    const currVal_67:any = '';
    _ck(_v,56,0,currVal_67);
    const currVal_68:any = _co.currentCatalog.sku;
    _ck(_v,59,0,currVal_68);
    const currVal_69:any = 'SKU';
    const currVal_70:any = '';
    _ck(_v,62,0,currVal_69,currVal_70);
    const currVal_73:any = 'row';
    const currVal_74:any = 'column';
    _ck(_v,77,0,currVal_73,currVal_74);
    const currVal_75:any = '30px';
    const currVal_76:any = '14px';
    _ck(_v,78,0,currVal_75,currVal_76);
    const currVal_77:any = 'padded-container';
    _ck(_v,79,0,currVal_77);
    const currVal_89:any = '47%';
    _ck(_v,89,0,currVal_89);
    const currVal_103:any = _co.currentCatalog.description;
    _ck(_v,94,0,currVal_103);
    const currVal_104:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,97,0,_ck(_v,98,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'description',_co._authService.getLanguage())),
        '');
    _ck(_v,97,0,currVal_104);
    const currVal_105:any = 'row';
    const currVal_106:any = 'column';
    _ck(_v,103,0,currVal_105,currVal_106);
    const currVal_107:any = '30px';
    const currVal_108:any = '14px';
    _ck(_v,104,0,currVal_107,currVal_108);
    const currVal_109:any = 'padded-container';
    _ck(_v,105,0,currVal_109);
    const currVal_121:any = '47%';
    _ck(_v,115,0,currVal_121);
    const currVal_136:any = _co.currentCatalog.notes;
    _ck(_v,120,0,currVal_136);
    const currVal_137:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,123,0,_ck(_v,124,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'notes',_co._authService.getLanguage())),
        '');
    _ck(_v,123,0,currVal_137);
    const currVal_139:any = 'bg-grey color-white text-only';
    _ck(_v,131,0,currVal_139);
    const currVal_141:boolean = !_co._authService.isViewer();
    _ck(_v,136,0,currVal_141);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_7:any = (null as any);
    const currVal_8:any = true;
    const currVal_9:any = i1.ɵnov(_v,11)._isErrorState();
    const currVal_10:any = i1.ɵnov(_v,11)._mdInputChild.focused;
    const currVal_11:any = i1.ɵnov(_v,11)._shouldForward('untouched');
    const currVal_12:any = i1.ɵnov(_v,11)._shouldForward('touched');
    const currVal_13:any = i1.ɵnov(_v,11)._shouldForward('pristine');
    const currVal_14:any = i1.ɵnov(_v,11)._shouldForward('dirty');
    const currVal_15:any = i1.ɵnov(_v,11)._shouldForward('valid');
    const currVal_16:any = i1.ɵnov(_v,11)._shouldForward('invalid');
    const currVal_17:any = i1.ɵnov(_v,11)._shouldForward('pending');
    _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17]);
    const currVal_19:any = (i1.ɵnov(_v,22).required? '': (null as any));
    const currVal_20:any = i1.ɵnov(_v,27).ngClassUntouched;
    const currVal_21:any = i1.ɵnov(_v,27).ngClassTouched;
    const currVal_22:any = i1.ɵnov(_v,27).ngClassPristine;
    const currVal_23:any = i1.ɵnov(_v,27).ngClassDirty;
    const currVal_24:any = i1.ɵnov(_v,27).ngClassValid;
    const currVal_25:any = i1.ɵnov(_v,27).ngClassInvalid;
    const currVal_26:any = i1.ɵnov(_v,27).ngClassPending;
    const currVal_27:any = true;
    const currVal_28:any = i1.ɵnov(_v,28).id;
    const currVal_29:any = i1.ɵnov(_v,28).placeholder;
    const currVal_30:any = i1.ɵnov(_v,28).disabled;
    const currVal_31:any = i1.ɵnov(_v,28).required;
    const currVal_32:any = (i1.ɵnov(_v,28).ariaDescribedby || (null as any));
    _ck(_v,20,1,[currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,
        currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,
        currVal_32]);
    const currVal_37:any = true;
    _ck(_v,31,0,currVal_37);
    const currVal_38:any = i1.ɵunv(_v,34,0,_ck(_v,35,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'required',_co._authService.getLanguage()));
    _ck(_v,34,0,currVal_38);
    const currVal_39:any = true;
    _ck(_v,37,0,currVal_39);
    const currVal_40:any = i1.ɵunv(_v,40,0,_ck(_v,41,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'must_be_unique',_co._authService.getLanguage()));
    _ck(_v,40,0,currVal_40);
    const currVal_41:any = (null as any);
    const currVal_42:any = true;
    const currVal_43:any = i1.ɵnov(_v,45)._isErrorState();
    const currVal_44:any = i1.ɵnov(_v,45)._mdInputChild.focused;
    const currVal_45:any = i1.ɵnov(_v,45)._shouldForward('untouched');
    const currVal_46:any = i1.ɵnov(_v,45)._shouldForward('touched');
    const currVal_47:any = i1.ɵnov(_v,45)._shouldForward('pristine');
    const currVal_48:any = i1.ɵnov(_v,45)._shouldForward('dirty');
    const currVal_49:any = i1.ɵnov(_v,45)._shouldForward('valid');
    const currVal_50:any = i1.ɵnov(_v,45)._shouldForward('invalid');
    const currVal_51:any = i1.ɵnov(_v,45)._shouldForward('pending');
    _ck(_v,44,1,[currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,currVal_46,
        currVal_47,currVal_48,currVal_49,currVal_50,currVal_51]);
    const currVal_53:any = (i1.ɵnov(_v,56).required? '': (null as any));
    const currVal_54:any = i1.ɵnov(_v,61).ngClassUntouched;
    const currVal_55:any = i1.ɵnov(_v,61).ngClassTouched;
    const currVal_56:any = i1.ɵnov(_v,61).ngClassPristine;
    const currVal_57:any = i1.ɵnov(_v,61).ngClassDirty;
    const currVal_58:any = i1.ɵnov(_v,61).ngClassValid;
    const currVal_59:any = i1.ɵnov(_v,61).ngClassInvalid;
    const currVal_60:any = i1.ɵnov(_v,61).ngClassPending;
    const currVal_61:any = true;
    const currVal_62:any = i1.ɵnov(_v,62).id;
    const currVal_63:any = i1.ɵnov(_v,62).placeholder;
    const currVal_64:any = i1.ɵnov(_v,62).disabled;
    const currVal_65:any = i1.ɵnov(_v,62).required;
    const currVal_66:any = (i1.ɵnov(_v,62).ariaDescribedby || (null as any));
    _ck(_v,54,1,[currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58,
        currVal_59,currVal_60,currVal_61,currVal_62,currVal_63,currVal_64,currVal_65,
        currVal_66]);
    const currVal_71:any = true;
    _ck(_v,64,0,currVal_71);
    const currVal_72:any = true;
    _ck(_v,69,0,currVal_72);
    const currVal_78:any = (null as any);
    const currVal_79:any = true;
    const currVal_80:any = i1.ɵnov(_v,82)._isErrorState();
    const currVal_81:any = i1.ɵnov(_v,82)._mdInputChild.focused;
    const currVal_82:any = i1.ɵnov(_v,82)._shouldForward('untouched');
    const currVal_83:any = i1.ɵnov(_v,82)._shouldForward('touched');
    const currVal_84:any = i1.ɵnov(_v,82)._shouldForward('pristine');
    const currVal_85:any = i1.ɵnov(_v,82)._shouldForward('dirty');
    const currVal_86:any = i1.ɵnov(_v,82)._shouldForward('valid');
    const currVal_87:any = i1.ɵnov(_v,82)._shouldForward('invalid');
    const currVal_88:any = i1.ɵnov(_v,82)._shouldForward('pending');
    _ck(_v,81,1,[currVal_78,currVal_79,currVal_80,currVal_81,currVal_82,currVal_83,
        currVal_84,currVal_85,currVal_86,currVal_87,currVal_88]);
    const currVal_90:any = i1.ɵnov(_v,96).ngClassUntouched;
    const currVal_91:any = i1.ɵnov(_v,96).ngClassTouched;
    const currVal_92:any = i1.ɵnov(_v,96).ngClassPristine;
    const currVal_93:any = i1.ɵnov(_v,96).ngClassDirty;
    const currVal_94:any = i1.ɵnov(_v,96).ngClassValid;
    const currVal_95:any = i1.ɵnov(_v,96).ngClassInvalid;
    const currVal_96:any = i1.ɵnov(_v,96).ngClassPending;
    const currVal_97:any = true;
    const currVal_98:any = i1.ɵnov(_v,97).id;
    const currVal_99:any = i1.ɵnov(_v,97).placeholder;
    const currVal_100:any = i1.ɵnov(_v,97).disabled;
    const currVal_101:any = i1.ɵnov(_v,97).required;
    const currVal_102:any = (i1.ɵnov(_v,97).ariaDescribedby || (null as any));
    _ck(_v,91,1,[currVal_90,currVal_91,currVal_92,currVal_93,currVal_94,currVal_95,
        currVal_96,currVal_97,currVal_98,currVal_99,currVal_100,currVal_101,currVal_102]);
    const currVal_110:any = (null as any);
    const currVal_111:any = true;
    const currVal_112:any = i1.ɵnov(_v,108)._isErrorState();
    const currVal_113:any = i1.ɵnov(_v,108)._mdInputChild.focused;
    const currVal_114:any = i1.ɵnov(_v,108)._shouldForward('untouched');
    const currVal_115:any = i1.ɵnov(_v,108)._shouldForward('touched');
    const currVal_116:any = i1.ɵnov(_v,108)._shouldForward('pristine');
    const currVal_117:any = i1.ɵnov(_v,108)._shouldForward('dirty');
    const currVal_118:any = i1.ɵnov(_v,108)._shouldForward('valid');
    const currVal_119:any = i1.ɵnov(_v,108)._shouldForward('invalid');
    const currVal_120:any = i1.ɵnov(_v,108)._shouldForward('pending');
    _ck(_v,107,1,[currVal_110,currVal_111,currVal_112,currVal_113,currVal_114,currVal_115,
        currVal_116,currVal_117,currVal_118,currVal_119,currVal_120]);
    const currVal_122:boolean = !_co._authService.isAdmin();
    const currVal_123:any = i1.ɵnov(_v,122).ngClassUntouched;
    const currVal_124:any = i1.ɵnov(_v,122).ngClassTouched;
    const currVal_125:any = i1.ɵnov(_v,122).ngClassPristine;
    const currVal_126:any = i1.ɵnov(_v,122).ngClassDirty;
    const currVal_127:any = i1.ɵnov(_v,122).ngClassValid;
    const currVal_128:any = i1.ɵnov(_v,122).ngClassInvalid;
    const currVal_129:any = i1.ɵnov(_v,122).ngClassPending;
    const currVal_130:any = true;
    const currVal_131:any = i1.ɵnov(_v,123).id;
    const currVal_132:any = i1.ɵnov(_v,123).placeholder;
    const currVal_133:any = i1.ɵnov(_v,123).disabled;
    const currVal_134:any = i1.ɵnov(_v,123).required;
    const currVal_135:any = (i1.ɵnov(_v,123).ariaDescribedby || (null as any));
    _ck(_v,117,1,[currVal_122,currVal_123,currVal_124,currVal_125,currVal_126,currVal_127,
        currVal_128,currVal_129,currVal_130,currVal_131,currVal_132,currVal_133,currVal_134,
        currVal_135]);
    const currVal_138:any = true;
    _ck(_v,128,0,currVal_138);
    const currVal_140:any = i1.ɵunv(_v,132,0,_ck(_v,133,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        0),'items_included',_co._authService.getLanguage()));
    _ck(_v,132,0,currVal_140);
  });
}
function View_CatalogComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),35,'md-card',([] as any[]),
      [[2,'mat-card',(null as any)]],(null as any),(null as any),i6.View_MdCard_0,
      i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n          '])),(_l()(),i1.ɵeld(0,(null as any),0,27,'md-card-header',
          [['fxLayout','column']],[[2,'mat-card-header',(null as any)]],(null as any),
          (null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n              '])),
      (_l()(),i1.ɵeld(0,(null as any),1,15,'md-card-title',([] as any[]),[[2,'mat-card-title',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          10,'span',[['class','md-title'],['fxFlex','100']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i8.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],
              [3,i9.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',' /\n                    '])),
      i1.ɵppd(2),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),
          [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,19).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i13.RouterLinkWithHref,
          [i13.Router,i13.ActivatedRoute,i11.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' / ','\n                  '])),(_l()(),i1.ɵted((null as any),
          ['\n              '])),(_l()(),i1.ɵted(2,['\n              '])),(_l()(),
          i1.ɵand(16777216,(null as any),1,1,(null as any),View_CatalogComponent_3)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(2,['\n              '])),
      (_l()(),i1.ɵand(16777216,(null as any),1,1,(null as any),View_CatalogComponent_4)),
      i1.ɵdid(16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(2,['\n          '])),(_l()(),
          i1.ɵted(0,['\n          '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,
          (null as any),View_CatalogComponent_5)),i1.ɵdid(16384,(null as any),0,i11.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted(0,['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = 'column';
    _ck(_v,7,0,currVal_2);
    const currVal_4:any = '100';
    _ck(_v,14,0,currVal_4);
    const currVal_5:any = 'md-title';
    _ck(_v,15,0,currVal_5);
    const currVal_9:any = _ck(_v,20,0,'/purchasing/catalogs');
    _ck(_v,19,0,currVal_9);
    const currVal_12:any = _co.isEditMode;
    _ck(_v,27,0,currVal_12);
    const currVal_13:boolean = !_co.isEditMode;
    _ck(_v,30,0,currVal_13);
    const currVal_14:any = _co.currentCatalog;
    _ck(_v,34,0,currVal_14);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = true;
    _ck(_v,4,0,currVal_1);
    const currVal_3:any = true;
    _ck(_v,9,0,currVal_3);
    const currVal_6:any = i1.ɵunv(_v,16,0,_ck(_v,17,0,i1.ɵnov((<any>_v.parent),0),
        'purchasing',_co._authService.getLanguage()));
    _ck(_v,16,0,currVal_6);
    const currVal_7:any = i1.ɵnov(_v,19).target;
    const currVal_8:any = i1.ɵnov(_v,19).href;
    _ck(_v,18,0,currVal_7,currVal_8);
    const currVal_10:any = i1.ɵunv(_v,21,0,_ck(_v,22,0,i1.ɵnov((<any>_v.parent),0),
        'catalogs',_co._authService.getLanguage()));
    _ck(_v,21,0,currVal_10);
    const currVal_11:any = ((_co.isEditMode && _co.currentCatalog)? _co.currentCatalog.name: _co.title);
    _ck(_v,23,0,currVal_11);
  });
}
export function View_CatalogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i14.TranslatePipe,([] as any[])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),12,'div',[['fxLayout','column']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n  \n\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CatalogComponent_1)),i1.ɵdid(16384,(null as any),
          0,i11.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          5,'div',[['class','boxed-content-wrapper cards-no-gaps']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CatalogComponent_2)),i1.ɵdid(212992,
          (null as any),0,i15.TdLoadingDirective,[i1.ViewContainerRef,i1.TemplateRef,
              i16.TdLoadingService],{name:[0,'name'],type:[1,'type'],mode:[2,'mode'],
              strategy:[3,'strategy'],color:[4,'color']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i17.CatalogComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.changed();
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = 'boxed-content-wrapper cards-no-gaps';
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = 'loading';
    const currVal_4:any = 'circle';
    const currVal_5:any = 'indeterminate';
    const currVal_6:any = 'overlay';
    const currVal_7:any = 'accent';
    _ck(_v,11,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  },(null as any));
}
export function View_CatalogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-catalog',
      ([] as any[]),(null as any),(null as any),(null as any),View_CatalogComponent_0,
      RenderType_CatalogComponent)),i1.ɵdid(114688,(null as any),0,i17.CatalogComponent,
      [i18.TdDialogService,i16.TdLoadingService,i19.CatalogService,i20.AuthenticationService,
          i7.MdDialog,i13.ActivatedRoute,i13.Router,i11.Location],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const CatalogComponentNgFactory:i1.ComponentFactory<i17.CatalogComponent> = i1.ɵccf('app-catalog',
    i17.CatalogComponent,View_CatalogComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/purchasing/catalogs/catalog/catalog.component.ngfactory.ts